import { PaymentsAbTestOrg } from '@wetags/payments-ab-test';
import { InvoiceModel } from '@frontend/api-invoices';
import { pendo } from '@frontend/tracking';
import { InvoiceCardActionsProps } from './invoice-card/types';
import { InvoiceCardActions as InvoiceCardActionsV1 } from './invoice-card/v1/invoice-card-actions';
import { InvoiceCardActions as InvoiceCardActionsV2 } from './invoice-card/v2/invoice-card-actions';

// TODO: A/B Test Feb 16, 2026, remove when done
export const InvoiceCardActions = ({
  onClickCollect,
  onClickRemind,
  onClickDelete,
  onClickView,
  ...rest
}: InvoiceCardActionsProps) => {
  const [newInvoiceCard] = PaymentsAbTestOrg.useWetag('payments-panel-new-invoice-card', {});

  const handleCollectClick = (invoice: InvoiceModel) => {
    pendo.track('invoice_card_collect_clicked', {
      newInvoiceCard: !!newInvoiceCard,
    });
    onClickCollect(invoice);
  };

  const handleRemindClick = (invoice: InvoiceModel) => {
    pendo.track('invoice_card_remind_clicked', {
      newInvoiceCard: !!newInvoiceCard,
    });
    onClickRemind(invoice);
  };

  const handleViewClick = (invoice: InvoiceModel) => {
    pendo.track('invoice_card_view_clicked', {
      newInvoiceCard: !!newInvoiceCard,
    });
    onClickView(invoice);
  };

  const handleDeleteClick = (invoice: InvoiceModel) => {
    pendo.track('invoice_card_delete_clicked', {
      newInvoiceCard: !!newInvoiceCard,
    });
    onClickDelete(invoice);
  };

  return newInvoiceCard ? (
    <InvoiceCardActionsV2
      {...rest}
      onClickCollect={handleCollectClick}
      onClickRemind={handleRemindClick}
      onClickView={handleViewClick}
      onClickDelete={handleDeleteClick}
    />
  ) : (
    <InvoiceCardActionsV1
      {...rest}
      onClickCollect={handleCollectClick}
      onClickRemind={handleRemindClick}
      onClickView={handleViewClick}
      onClickDelete={handleDeleteClick}
    />
  );
};
